// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3L-cy","actions":"GroupTable_actions__yvwD_","deleteModalFooter":"GroupTable_deleteModalFooter__3eC2f"};